import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@app/../environments/environment';
import { AuthenticateService } from '@app/api/authenticate.service';
import { BlogPostDetail } from '@app/model/blog-content.model';
import { BlogContentDataService } from '@app/services/blog-content-data.service';
import { of, Subject } from 'rxjs';
import { catchError, switchMap, takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'meu-blog-detail',
  templateUrl: './blog-detail.component.html',
  styleUrls: ['./blog-detail.component.scss']
})
export class BlogDetailComponent implements OnInit, OnDestroy {
  post: BlogPostDetail;

  avatarUrl = '/assets/media/users/default-avatar.png';

  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private blogContentDataService: BlogContentDataService,
    private authenticateService: AuthenticateService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.route.paramMap
      .pipe(
        switchMap((params) => {
          const postSlug = params.get('slug') || '';

          return this.blogContentDataService.getPostBySlug(postSlug);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (post) => {
          const currentSlug = this.route.snapshot.paramMap.get('slug');

          this.post = post;
          this.loadAuthorAvatar(post.createdBy);

          if (post.slug && post.slug !== currentSlug) {
            this.router.navigate(['/blog', post.slug], {
              replaceUrl: true
            });
          }


          try {
            this.changeDetectorRef.detectChanges();
          } catch (error) {
            // view already destroyed / detection in progress – safe to ignore
          }
        },
        error: (error) => {
          console.error('Failed to load blog post:', error);
          this.router.navigate(['/blog']);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadAuthorAvatar(authorId: string | null): void {
    this.avatarUrl = '/assets/media/users/default-avatar.png';

    if (!authorId) {
      return;
    }

    this.authenticateService
      .apiAuthenticateGetMyInfoGet()
      .pipe(
        catchError(() => of(null)),
        takeUntil(this.destroy$)
      )
      .subscribe((response) => {
        const user = response && response.user;

        if (!user || user.id !== authorId || !user.avatar) {
          return;
        }

        this.avatarUrl =
          user.avatar.indexOf('http') === 0 ? user.avatar : environment.backendhost + user.avatar;
      });
  }
}
